import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { updateUserInfo, setHeader, connectSlack } from '../actions'

const Setting = (props) => (
  props.user.initialized ?
    <SettingForm allProps={props} />
  :
    <div>Loading...</div>
)

class SettingForm extends Component {
  componentWillMount() {
    const { initialize, user, setHeader } = this.props.allProps
    initialize({ 
      uid: user.uid,
      realName: user.realName? user.realName: user.emailName,
      nickName: user.nickName? user.nickName: "",
      position: user.position? user.position: "",
      introduction: user.introduction? user.introduction: ""
    })
    setHeader({
      title: "ユーザー設定",
      left: null,
      right: null
    })
  }
  render() {
    const { user, teams, handleSubmit, updateUserInfo, connectSlack } = this.props.allProps
    return (
      <div className="setting content">
        <form onSubmit={handleSubmit(values => updateUserInfo(values))} >
          <Field name="uid" component="input" type="hidden" />
          <div className="field">
            <label className="label">メールアドレス</label>
            <div className="control">
              <p>{user.email}</p>
            </div>
          </div>
          <div className="field">
            <label className="label">Slack</label>
            <div className="control">
              {user.slackName?
                <div className="slack"><img src={user.images.x32} alt={user.slackName} /> <span>@{user.slackName}</span></div>
              :
                <button type="button" className="button" onClick={() => connectSlack(user)}>Slack 同期</button>
              }
            </div>
          </div>
          <div className="field">
            <label className="label">所属</label>
            <div className="control">
              {user.teams? 
                user.teams.map((team, index) => 
                  <span key={index}>{(index > 0)? ", " : "" }{teams[team].name}</span>
                )
              :
                null
              }
            </div>
          </div>
          <div className="field">
            <label className="label">役職</label>
            <div className="control">
              <Field name="position" component="input" type="text" className="input" />
            </div>
          </div>
          <div className="field">
            <label className="label">名前</label>
            <div className="control">
              <Field name="realName" component="input" type="text" className="input" />
            </div>
          </div>
          <div className="field">
            <label className="label">ニックネーム</label>
            <div className="control">
              <Field name="nickName" component="input" type="text" className="input" />
            </div>
          </div>
          <div className="field">
            <label className="label">プロフィール</label>
            <div className="control">
            <Field name="introduction" component="textarea" className="textarea" />
            </div>
          </div>
          <div className="is-clearfix">
            <button type="submit" className="button is-pulled-right">更 新</button>
            <button type="button" className="button is-pulled-right slack-button" onClick={() => connectSlack(user)}>Slack 同期</button>
          </div>
        </form>
      </div>
    )
  }
}
export default connect(
  state => ({ 
    user: state.user,
    teams: state.organization.teams
  }),
  { updateUserInfo, setHeader, connectSlack }
)(reduxForm({ form: 'setting' })(Setting))


// WEBPACK FOOTER //
// ./src/containers/Setting.js